/**
 * Point d'entrée centralisé pour tous les services de l'application
 * Cela permet d'importer facilement tous les services dans un composant
 * Exemple: import { dataService, syncService } from '@/services';
 */

import dataService from './dataService';
import syncService from './syncService';
import logService from './logService';
import updateService from './updateService';

// Initialisation
const initializeServices = async () => {
  try {
    await dataService.init();
    return true;
  } catch (error) {
    console.error("Erreur lors de l'initialisation des services:", error);
    return false;
  }
};

// Exportation des services individuels
export {
  dataService,
  syncService,
  logService,
  updateService,
  initializeServices
};

// Exportation de tous les services comme objet par défaut
export default {
  data: dataService,
  sync: syncService,
  log: logService,
  update: updateService,
  initialize: initializeServices
}; 